import * as catalogueAPIUtil from "../../util/catalogue/catalogueAPIUtil";
import { clearToken, safeRemoveStorageItem } from "../../util/auth/tokenStorage";
export const RECEIVE_CATALOGUE_CATEGORIES_NAV = "[Categories] RECEIVE_CATALOGUE_CATEGORIES_NAV";
export const receiveCatalogueCategoriesNav = (categories) => ({
    type: RECEIVE_CATALOGUE_CATEGORIES_NAV,
    payload: categories
});
export const fetchCatalogueCategoriesNav = (session) => dispatch => catalogueAPIUtil.fetchCatalogueCategories(session)
    .then(res => {
        const categoriesData = res.data.data;
        let data = [];
        categoriesData.map(categoryArray => {
            if (Number(categoryArray.totalProducts) > 0) {
                data.push({ id: categoryArray.id, category: categoryArray.category, totalProducts: categoryArray.totalProducts });
            }
        })
        dispatch(receiveCatalogueCategoriesNav(data))
    }).catch(error => {
    if (error.response && error.response.data && error.response.data.status == 401) {
      clearToken()
      safeRemoveStorageItem(localStorage, 'cpPendingArtwork')
      window.location.replace('/cp/login')
    }
    });
